<app-nav></app-nav>
<div class="container11">
  <div class="header mis-screen">
    <div class="mis-filter">
      <h3 class="center">Referral List</h3>
    </div>

    <!-- <h1>Popular Posts</h1> -->
  </div>
  <ul class="disa_6">
    <li *ngFor="let referral of referralistdetails; index as i" [ngClass]="{'disable_list' : referral.disable}">
      <div class="row">
      
        <div  class="col-md-1 col-2 col-lg-1">
        <div id="rcorners">
          <span class="first_referral" [ngClass]="{'is-referral_first' : referral.name.split(' ')[1] }">{{
            referral.name.substr(0,1).toUpperCase()}}</span>
          <span *ngIf="referral.name.split(' ')[1]" class="sec_ite"> {{ referral.name.split("
            ")[1].substr(0,1).toUpperCase()}} </span>
        </div>
      </div>

        <div class="refer_conte" class="col-md-10 col-lg-10 col-9">
          <div style="display: flex; justify-content: space-between"><div style="color:#000000; font-weight: 600;">{{referral.name}}</div>
          <div>

            <div class=" list_right referr_city " style="color: #777777;">{{referral.City}}</div>
          </div>
          </div> 
          <p *ngIf="referral.productName" style="color:#000000; font-size: 12px;" class="" [ngClass]="{'productNameFont' : referral.productName.length>40}">{{referral.productName}}</p>
          <p *ngIf="!referral.productName" style="color:#000000; font-size: 12px;" class="referr_prod">N.A.</p>
          <div style="display: flex; justify-content: space-between;">
            <div>
          <p class="referr_prod status-class mt-1 mb-1">Status: <span style="color: #000000;">{{referral.status}}</span></p>
          <p *ngIf="referral.signUp===true"  class="referr_prod status-class mt-1 mb-1">Sign-Up: <span style="color: #000000;">Yes</span></p>
          <p *ngIf="referral.signUp===false" class="referr_prod status-class mt-1 mb-1">Sign-Up: <span style="color: #000000;">No</span></p>
        </div>
        <div>
          <div class=" list_right referr_city" *ngIf="referral.disable">
            Deleted
          </div>
          <div class="list_right row" *ngIf="!referral.disable">
        
            <div *ngIf="!referral.signUp"> <button class="btn btn-orange referral_but referral_but1"
                id="{{referral._id}}"  (click)="reminderReferralUser(referral);"
                (click)="reminderLoginUser(referral);" [disabled]="">Send a Reminder</button>
                <span class="ml-1">
                  <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/delete_icon_web.svg" data-toggle="modal" data-target=".bs-example-modal-new"
                    (click)="deleteReferrallist1(referral._id);" [disabled]="referral.disable" class="pointer">
                </span></div>
            <div *ngIf="referral.signUp"> <button class="btn btn-orange "
                style="margin-left:10px;visibility: hidden;">No Reminder</button>
                <span class="wrap col text-right">
                  <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/delete_icon_web.svg" data-toggle="modal" data-target=".bs-example-modal-new"
                    (click)="deleteReferrallist1(referral._id);" [disabled]="referral.disable" class="pointer">
                </span></div>
            
    
        
    
     
          </div>
        </div>
        </div>

        </div>
     

     </div>
    </li>
  </ul>
  
  <div class="container refers" *ngIf="!isShowReferral">
    <img src="assets/images/refer.jpg" />
    <h5 class="head">Oops ! You have not referred anyone yet. Click on the button below to refer our products to your
      friends and win cash points for Amazon voucher.</h5>
    <button class="btn btn-orange mt-4 btn-padding" (click)="referFormSection = true; referInfoSection = false;"
      routerLink="/refer">Refer Product</button>
  </div>
</div>


<!-- start add list from pam:: -->
<!-- <div class="container11">
<ul class="disa_6">
  <li *ngFor="let pamRfl of pamReferral; index as i">
    <a>
      <div id="rcorners">
          <span class="first_referral">{{
          pamRfl.name.substr(0,1).toUpperCase()}}</span>    
      </div>

      <div class="refer_conte">
        <h1 class="referr_name">{{pamRfl.name}}</h1>
        <p class="referr_prod">{{pamRfl.mobile}}</p>
        <p class="referr_city">{{pamRfl.email}}</p>

      </div>
    </a>

  </li>
</ul>
</div> -->

<!-- end add list from pam -->

<div class="modal fade" id="checkReminder">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group text-center">
          You have sent a reminder.
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer text-center">
        <div class="container">
          <div class="col-md-12 text-center">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade bs-example-modal-new" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true">

  <div class="modal-dialog">

    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>

      </div>

      <div class="modal-body">
        <div class="body-message">
          <p>Are you sure you want to delete this referral?</p>
        </div>
      </div>

      <div class="modal-footer">
        <div type="button" class="btn btn-primary" data-dismiss="modal" (click)="deleteReferrallist();">Yes</div>
        <button type="button" class="btn btn-primary" data-dismiss="modal" routerLink="/referrallist">No</button>
      </div>

    </div>

  </div>

</div>



<div class="modal fade" id="checkReminder">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group text-center">
          You have sent a reminder.
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer text-center">
        <div class="container">
          <div class="col-md-12 text-center">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div>

</div>